"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var styled_1 = __importDefault(require("@emotion/styled"));
var react_1 = __importStar(require("react"));
var getSmallAvatar = function (avatar) {
    var _a, _b;
    if (!avatar)
        return '';
    var ext = (_b = (_a = avatar === null || avatar === void 0 ? void 0 : avatar.split('.')) === null || _a === void 0 ? void 0 : _a.pop()) === null || _b === void 0 ? void 0 : _b.toLowerCase();
    return avatar.replace(".".concat(ext), "/80h.".concat(ext));
};
var Img = styled_1.default.img(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    object-fit: cover;\n    width: 32px;\n    height: 32px;\n    margin-right: 8px;\n"], ["\n    object-fit: cover;\n    width: 32px;\n    height: 32px;\n    margin-right: 8px;\n"])));
var Avatar = function (_a) {
    var user = _a.user, _b = _a.className, className = _b === void 0 ? '' : _b;
    var defaultAvatarId = (0, react_1.useRef)(Math.floor(Math.random() * 5) + 1);
    var url = user.avatar_url
        ? getSmallAvatar(user.avatar_url)
        : "https://media.giphy.com/avatars/default".concat(defaultAvatarId.current, ".gif");
    return react_1.default.createElement(Img, { src: url, className: className });
};
exports.default = Avatar;
var templateObject_1;
//# sourceMappingURL=avatar.js.map